import { useState } from "react";

import { RxHamburgerMenu } from "react-icons/rx";
import { AiOutlineClose } from "react-icons/ai";

const Navbar = () => {
  const [showNav, setShowNav] = useState(false);

  const navbarHandler = (e) => {
    e.preventDefault();
    setShowNav(!showNav);
  };

  const titleClasses =
    "text-white  text-[1.2rem] desktop:text-[1.5rem] ml-[2rem] hover:border-b-2 hover:border-white  duration-300 hover:mb-[-4px]";

  const hamburguerTitleClasses = "text-gray-600  text-[1.5rem] mb-[1rem] hover:border-b-2 hover:border-white  duration-300 hover:mb-[-4px]";


  return (
    <section>
      <article className="flex flex-row items-center justify-between w-full  z-10">
        <img src="/logo1.svg" alt="" className=" w-[4rem] notebook:w-[6rem] desktop:w-[10rem] " />
        <div className="hidden notebook:flex flex-row ">
          <a href="#about-us" className={titleClasses}>
            about us
          </a>
          <a href="https://wa.me/15618976749"  className={titleClasses}>
            contact
          </a>
        </div>
        <RxHamburgerMenu
          className="notebook:hidden text-white text-[1.5rem]"
          onClick={navbarHandler}
        />
      </article>

      <article
        className={
          !showNav
            ? "fixed top-0 left-0 right-0 min-h-screen px-4 pt-8 space-y-4 bg-white text-black transform transition duration-300 translate-x-full"
            : "fixed top-0 left-0 right-0 min-h-screen px-4 pt-8 space-y-4 bg-white text-black transform transition duration-300 translate-x-0  z-10"
        }
      >
        <AiOutlineClose
          onClick={navbarHandler}
          className="text-[2rem] text-right  my-[2rem] font-bold text-gray-500 w-full "
        />

        <div className="py-[5rem] text-center flex flex-col justify-center text-[1.5rem] font-light text-gray-600 ">
          <a href="#about-us" className={hamburguerTitleClasses}>
            about us
          </a>
          <a href="https://wa.me/13054973070" className={hamburguerTitleClasses}>
            contact
          </a>
          <img src="/logo1.svg" alt="" className=" w-[6rem] mt-[4rem] mx-auto  " />
        </div>
      </article>
    </section>
  );
};

export default Navbar;
